import locale from "localization";

export const payWithPesoColumns = [
  {
    key: "paymentId",
    text: locale.locqpayForFuelId,
    style: {
      minWidth: "70px",
    },
  },
  {
    key: "createdAt",
    text: locale.dateOfTransaction,
    style: {
      minWidth: "70px",
    },
  },
  {
    key: "nameAndMobileNumber",
    text: (
      <>
        {locale.name} / <br /> {locale.mobileNumber}
      </>
    ),
    style: { minWidth: "10%" },
  },
  {
    key: "product",
    text: locale.product,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "computedVolume",
    text: locale.computedVol,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "amount",
    text: locale.paymentAmount,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "discount",
    text: locale.discount,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "effectiveDiscount",
    text: locale.effectiveDiscountPerLiter,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "finalAmountPaid",
    text: locale.finalAmountPaid,
    style: {
      minWidth: "100px",
    },
  },

  {
    key: "status",
    text: `${locale.status}`,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "settlementStatus",
    text: `${locale.settlementStatus} / ${locale.settlementId}`,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "action",
    text: `${locale.action}`,
    style: {
      minWidth: "120px",
    },
  },
];
